import { render, staticRenderFns } from "./fracionamento.vue?vue&type=template&id=cb6a52c8"
import script from "./fracionamento.ts?vue&type=script&lang=js&external"
export * from "./fracionamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb6a52c8')) {
      api.createRecord('cb6a52c8', component.options)
    } else {
      api.reload('cb6a52c8', component.options)
    }
    module.hot.accept("./fracionamento.vue?vue&type=template&id=cb6a52c8", function () {
      api.rerender('cb6a52c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produtolote/fracionamento.vue"
export default component.exports